import React from 'react';
import { Step } from 'semantic-ui-react';
import { states } from '@/constants/lifecycle';
import WizardStep from '@/components/wizard/WizardStep';
import { workspaceRequestSteps } from '../constants';
import Selectors from '../hooks/selectors';

const WorkspaceSteps = ({ code, compact, goToStep }) => {
  const { activeStepIndex, saveStatus } = Selectors.useWorkspaceSteps({ code });
  const steps = Object.values(workspaceRequestSteps);
  const activeStep = steps[activeStepIndex].name;
  const names = steps.map(({ name }) => name);

  return (
    <Step.Group
      fluid={compact}
      size={compact ? 'mini' : 'tiny'}
      vertical={!compact}
      className="aridhia-workspace-steps"
    >
      {[0, 1].map((i) => (
        <WizardStep
          activeStep={activeStep}
          disabled={[states.PENDING, states.SUCCESS].includes(saveStatus)}
          entity="workspace"
          icon={steps[i].icon}
          index={i}
          key={`workspace_step${steps[i].name}`}
          onClick={goToStep}
          steps={names}
        />
      ))}
    </Step.Group>
  );
};

export default WorkspaceSteps;
